<template>
  <Navbar />
  <div class="content-wrapper">
    <div class="main-content mt-80">
      <section class="pt-50 pb-60 lg:pt-30">
        <div class="container pt-10">
          <div class="row">
            <div class="col-lg-8 mb-30" data-aos="fade-up" :data-aos-delay="200">
              <singleBlogContent />
            </div>

            <div class="col-lg-4" data-aos="fade-up" :data-aos-delay="250">
              <Sidebar />
            </div>
          </div>

          <div>
            <RecentCourses :latestCourses="latestCourses" :recent="false" />
          </div>
          <related-articles />
        </div>
      </section>
    </div>
    <FooterItem />
  </div>
</template>

<script>
import AOS from "aos";
import Navbar from "@/components/Layout/Navbar.vue";
import singleBlogContent from "@/components/Blogs/singleBlogContent.vue";
import FooterItem from "@/components/Layout/FooterItem.vue";
import Sidebar from "@/components/Blogs/Sidebar.vue";
import RelatedArticles from "@/components/Blogs/RelatedArticles.vue";
import RecentCourses from "@/components/Homepage/RecentCourses.vue";
import { getLatestCourses } from "@/Services/api/CoursesService";
import { useHead } from "@vueuse/head";
import { mapGetters } from "vuex";
import store from "@/store";
export default {
  components: {
    Navbar,
    singleBlogContent,
    FooterItem,
    Sidebar,
    RelatedArticles,
    RecentCourses
  },
  computed: {
    ...mapGetters(["currentLanguage"]),
  },
  data() {
    return {
      latestCourses: []
    }
  },
  methods: {
    //recent courses
    async getRecentCourse() {
      try {
        const response = await getLatestCourses();
        this.latestCourses = response.data;
      } catch (error) {
        console.log(error.message)
      }
    },
    updateHeadMeta(blogTitle, blogDescription, blogImageUrl, blogUrl) {
      const title =
        this.currentLanguage === "ar"
          ? `${blogTitle} - مدونة Planning Force`
          : `${blogTitle} - Blog | Planning Force`;

      const description =
        this.currentLanguage === "ar"
          ? blogDescription ||
          "اكتشف المقالات التعليمية ومواضيع التدريب التي تقدمها منصة Planning Force."
          : blogDescription ||
          "Explore educational articles and training topics offered by Planning Force platform.";

      const keywords =
        this.currentLanguage === "ar"
          ? `مدونة, ${blogTitle}, تعلم, تعليم إلكتروني, Planning Force`
          : `blog, ${blogTitle}, learning, e-learning, Planning Force`;

      useHead({
        title: title,
        meta: [
          { name: "description", content: description },
          { name: "keywords", content: keywords },
          { name: "robots", content: "index, follow" },
          {
            name: "author",
            content:
              this.currentLanguage === "ar"
                ? "Planning Force"
                : "Planning Force",
          },
          {
            name: "language",
            content: this.currentLanguage === "ar" ? "ar" : "en",
          },

          // Open Graph meta tags
          { property: "og:title", content: title },
          { property: "og:description", content: description },
          {
            property: "og:image",
            content:
              blogImageUrl || "https://example.com/default-blog-image.jpg",
          }, // Replace with your image URL
          {
            property: "og:url",
            content: blogUrl || "https://example.com/blog/1",
          }, // Replace with your blog page URL
          { property: "og:type", content: "article" },

          // Twitter Card meta tags
          { name: "twitter:card", content: "summary_large_image" },
          { name: "twitter:title", content: title },
          { name: "twitter:description", content: description },
          {
            name: "twitter:image",
            content:
              blogImageUrl || "https://example.com/default-blog-image.jpg",
          }, // Replace with your image URL
        ],
      });
    },
  },
  watch: {
    currentLanguage: {
      handler(newLang, oldLang) {
        //  this.language = newLang;
        this.updateHeadMeta();
        store.dispatch("categoriesList");
        this.getRecentCourse();
      },
      immediate: true, // Run the handler immediately when the component is mounted
    },
  },
  mounted() {
    this.updateHeadMeta(
      "How to Build a Career in E-Learning",
      "Learn the key steps to building a successful career in e-learning and educational technology with insights from industry experts.",
      "https://example.com/images/career-in-elearning.jpg",
      "https://example.com/blog/how-to-build-a-career-in-elearning"
    );

    AOS.init({
      duration: 1000, // Animation duration
      once: true, // Whether animation should happen only once
    });
  },
};
</script>
